import "styles/layout/desktop-header.less";

import { FC, useState } from "react";

import { Badge } from "antd";
import aiChatLogo from "assets/images/ai-chat-logo.svg";
import taxzapLogo from "assets/images/taxzap-logo-R.svg";
import NewQuestionnaireNameCircle from "components/common/NewQuestionnaireNameCircle";
import TaxYearSelection from "components/common/TaxYearSelection";
import DropDownDesktop from "components/pages/Profile/tabs/Homepage/DropDownDesktop";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { setCurrentDocumentYear } from "redux/reducers/document";
import { RootState } from "redux/store";
import { IUser } from "types/auth";

import { getAccessToken } from "../../../../../utils/auth";
import { Step } from "../../constants/questions";
import ProgressDivider from "../ProgressDivider";

type HeaderProps = {
    user: IUser;
    handleContinue: () => void;
    currentStepData: Step;
    totalProgress: number;
};

const DesktopHeader: FC<HeaderProps> = ({ user, totalProgress }) => {
    const dispatch = useDispatch();
    const [showDropDown, setShowDropDown] = useState(false);
    const { isZappyEnabled } = useFlags();

    const { currentDocumentYear } = useAppSelector((state: RootState) => ({
        currentDocumentYear: state.document.currentDocumentYear,
        taxYears: state.taxYears.taxYears,
    }));

    const handleNotificationsClick = () => {
        setShowDropDown(prev => !prev);
    };

    const handleMenuClick = ({ key }: { key: string }) => {
        dispatch(setCurrentDocumentYear(key));
    };

    const handleChatClick = async () => {
        const token = await getAccessToken();
        // @ts-ignore
        window.$chatwoot?.setCustomAttributes({
            updatedAt: new Date().toISOString(),
            pendingQuestion: null,
            transactionId: null,
            totalAmount: null,
            description: null,
            token,
        });
        // @ts-ignore
        if (typeof window !== "undefined" && window.$chatwoot?.toggle) {
            // @ts-ignore
            window.$chatwoot.toggle("open");
        }
    };

    return (
        <>
            <div className="desktop-header">
                <Link to="/profile" className="desktop-header__profile-link">
                    <img className="logo-questionnaire" src={taxzapLogo} alt="TaxZap Logo" />
                </Link>
                <div
                    className="new-questionnaire__desktop-header-content"
                    style={{ display: "flex", alignItems: "center", gap: "24px" }}
                >
                    {/* Ask Zappy Button */}

                    {isZappyEnabled && (
                        <Badge.Ribbon
                            text="Beta"
                            color="primary"
                            style={{
                                top: -12,
                                fontSize: 12,
                                fontWeight: 600,
                            }}
                        >
                            <div
                                className="desktop-header__zappy"
                                onClick={handleChatClick}
                            >
                                <img
                                    src={aiChatLogo}
                                    alt="Ask Zappy"
                                    style={{
                                        height: "22px",
                                        objectFit: "contain",
                                    }}
                                />
                                <div className="desktop-header__zappy-title">Ask Zappy</div>
                            </div>
                        </Badge.Ribbon>
                    )}

                    <div >
                        <TaxYearSelection
                            onSelect={(value: string) => {
                                handleMenuClick({ key: value });
                            }}
                            placeholder={"Select Tax Year"}
                            value={currentDocumentYear}
                        />
                    </div>
                    <div>
                        <div className={`client__navbar ${showDropDown ? "active" : ""}`}
                            onClick={handleNotificationsClick}>
                            <NewQuestionnaireNameCircle firstName={user.info.firstName} lastName={user.info.lastName}/>
                            <div className="ml6">
                                <div
                                    className="desktop-header__client-name">{`${user.info.firstName} ${user.info.lastName}`}</div>
                                <div className="desktop-header__client-email">{user.info.email}</div>
                            </div>
                        </div>
                        <DropDownDesktop
                            showDropDown={showDropDown}
                            showToggle={handleNotificationsClick}
                        />
                    </div>
                </div>

            </div>
            <ProgressDivider progress={totalProgress}/>
        </>

    );
};

export default DesktopHeader;
